import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'tog-date-time-picker',
  templateUrl: 'date-time-picker.component.html',
  styleUrls: ['date-time-picker.component.scss']
})

export class DateTimePickerComponent implements OnInit {
  datePicker: any;
  dateTime: string;

  private _minDate: string;
  private _maxDate: string;
  private _initialDate: string;

  @Input() allowPastDates: boolean = false;
  @Input() control: FormControl;
  @Input() dateOnly: boolean = false;
  @Output('dateChanged') dateChanged = new EventEmitter();

  constructor(private _el: ElementRef) {
  }

  ngOnInit() {
    this.datepickerInit();
  }

  reset() {
    this.datepickerInit();
    let date = new Date();
    this.initialDate = date.toJSON();
  }

  @Input() set initialDate(initialDate: string) {
    this._initialDate = initialDate;
    if (initialDate) {
      let date = new Date(initialDate)
      this.setDate(date);
    }
  }

  @Input() set minDate(minDate: string) {
      this._minDate = minDate;
      if (minDate) this.setMinMaxDate();
  }

  @Input() set maxDate(maxDate: string) {
      this._maxDate = maxDate;
      if (maxDate) this.setMinMaxDate();
  }

  datepickerInit() {
    this.datePicker = $(this._el.nativeElement.getElementsByTagName('input')[0]);
    let options: any = {};
    if (!this.allowPastDates) options.minDate = new Date();
    if (this.dateOnly) options.format = 'L';
    this.datePicker.datetimepicker(options);

    if (this._minDate || this._maxDate) { this.setMinMaxDate(); }
    if (this._initialDate) {
      let date = new Date(this._initialDate);
      this.setDate(date);
    }
  }

  setMinMaxDate() {
    if (!this.datePicker) this.datepickerInit();
    let options: any = {};

    if (this._minDate) {
      let minDate = new Date(this._minDate);
      // If the minimum date is earlier than today, and we want to disallow past dates, adjust the minimum date
      if (!this.allowPastDates) {
        let currentDate = new Date();
        options.minDate = new Date(currentDate > minDate ? currentDate : minDate);
      } else options.minDate = minDate;
    }

    if (this._maxDate) options.maxDate = new Date(this._maxDate);
    options.useCurrent = false; // necessary to avoid weird glitches, see issue 1075 on Eonasdan/bootstrap-datetimepicker
    this.datePicker.data('DateTimePicker').destroy();
    this.datePicker.datetimepicker(options);
  }

  setDate(date: Date) {
    if (this.datePicker) {
      let hours = date.getHours();
      let month = date.getMonth() + 1;
      let monthStr: string = month.toString();
      let minutes = date.getMinutes();
      let minutesStr = minutes.toString();
      let day = date.getDate();
      let dayStr = day.toString();

      if (hours === 0) { hours = 12 }
      if (hours > 12) { hours = hours - 12; }
      if (month < 10) { monthStr = 0 + monthStr; }
      if (minutes < 10) { minutesStr = '0' + minutesStr; }
      if (day < 10) { dayStr = '0' + dayStr; }

      let finalString = monthStr + '/' + dayStr + '/' + date.getFullYear();
      if (!this.dateOnly) finalString += hours + ':' + minutesStr + (date.getHours() >= 12 ? ' PM' : ' AM')

      // this.datePicker[0].value = finalString;
      // let options: any = { defaultDate: date };
      // if (this.dateOnly) options.format = 'L';
      this.datePicker.data('DateTimePicker').date(date);
      this.datePicker.data('DateTimePicker').viewDate(date);
    }
  }

  update() {
    let date;
    if (this.datePicker[0].value != '') {
      date = new Date(this.datePicker[0].value);
      if (this.control) this.control.setValue(date.toJSON());
    } else {
      date = '';
      if (this.control) this.control.setValue(date);
    }
    this.dateChanged.emit(date);
  }
}




// WEBPACK FOOTER //
// /app/src/app/shared/components/date-time-picker/date-time-picker.component.ts